// extracted by mini-css-extract-plugin
export default {"numberOfAssessments":"CompanyAssessmentsList_numberOfAssessments__1V1Ix","displayMore":"CompanyAssessmentsList_displayMore__GmOjb"};